

export interface MetalsProject {
    id: string;
    name: string;
    code: string;
    customerId: string;
    createdById: string;
    createdOn: Date;
    updatedById: string;
    purchaseOrderNumber: string;
    labelDescription: string;
    updatedOn: Date;
    thumbnailDownloadUrl: string;
    status: MetalsProjectStatus;
    completedOn: Date | null;
    completedById: string;
    orderedProductId: string;
    sourceProductId?: string;
    sourceProductVersionId?: string;
    sourceTemplateProjectId?: string;
}

export enum MetalsProjectStatus {
    Active = 'Active',
    Completed = 'Completed',
    Canceled = 'Canceled',
    Template = 'Template',
    Draft = 'Draft',
}



